<template lang="pug">
template(v-if="field")
	label.v-field-checkbox.field-checkbox
		input.field-checkbox__input(
			type="checkbox"
			v-model="localValue"
			@change="handlerInput"
			:disabled="disabled"
			:aria-labelledby="uniqueId"
			:id="uniqueId")
		span.field-checkbox__visual
			transition(name="scale")
				v-checkbox-icon.field-checkbox__visual-icon(v-if="localValue" icon="checkbox-tick")
		span.field-checkbox__text(v-if="field.text" v-html="field.text")
	.field-checkbox__description(v-if="field.description" :style="{color: field.description.color}" v-html="field.description.text")
	.field-checkbox__note(v-if="field.note" :style="{color: field.note.color}" v-html="field.note.text")
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';


export default {
	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		modelValue: {
			type: Boolean,
			default: null
		},

		disabled: {
			type: Boolean,
			default: false
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			localValue: null,
			open: false,
			uniqueId: uniqueId('field-')
		};
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		}
	},

	created() {
		this.updateLocalValue();
	},

	methods: {
		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		handlerInput() {
			this.$emit('update:model-value', this.localValue, this.field);
		}
	}
};
</script>
